export function parralaxBlock() {
    const speedFactor = 0.05;
    const items       = document.querySelectorAll('.farlo-ui-parralax > *');

    const elems = Array.from(items).map((el, i) => ({
        el,
        top: el.getBoundingClientRect().top + window.pageYOffset,
        even: (i + 1) % 2 === 0
    }));

    let ticking = false;
    function onScroll(){
        if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
        }
    }

    function updateParallax(){
        const scrollY = window.pageYOffset;
        elems.forEach(({el, top, even}) => {
            const distance = (scrollY - top) * speedFactor;
            const translateY = even ?  distance : -distance;
            el.style.transform = `translate3d(0, ${translateY}px, 0)`;
        });
        ticking = false;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('load', updateParallax);
}